import React from 'react'
import Button from './BottomMenuButton'
import { Alert } from 'react-bootstrap'
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'

export default function BottomMenu({ text, textVariant = 'info', onPrev, onNext, disableNext = false, submitOnNext = false, onSkip, skipButtonLabel = 'Skip' }) {
  return (
    <div className="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 md:tw-p-6">
      <div className="md:tw-rounded-xl md:tw-shadow-xl tw-border-t tw-border-slate-300 md:tw-border-none tw-p-4 md:tw-p-6 tw-backdrop-blur-md tw-bg-white/30">
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
          {text && (
            <Alert variant={textVariant} style={{ marginBottom: 0 }}>
              {text}
            </Alert>
          )}
          {/* Skip rendered as a subtle text link on the left */}
          {onSkip && (
            <button
              type="button"
              onClick={onSkip}
              className="tw-text-sm tw-text-slate-400 hover:tw-text-slate-600 tw-underline tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0"
            >
              {skipButtonLabel}
            </button>
          )}
          <div className="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-3">
            {onPrev && (
              <Button prefixIcon={<FiArrowLeft />} onClick={onPrev}>
                Previous
              </Button>
            )}
            {(onNext || submitOnNext === true) && (
              <Button type={submitOnNext ? 'submit' : 'button'} suffixIcon={<FiArrowRight />} onClick={onNext} disabled={disableNext}>
                Next
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
